'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/6/28.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PersonalCenterTopBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PersonalCenterTopBar, _Component);

  function PersonalCenterTopBar() {
    (0, _classCallCheck3.default)(this, PersonalCenterTopBar);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PersonalCenterTopBar).apply(this, arguments));
  }

  (0, _createClass3.default)(PersonalCenterTopBar, [{
    key: 'render',
    value: function render() {
      var styles = require('./PersonalCenterTopBar.scss');
      var infos = this.props.infos;

      return _react2.default.createElement(
        'div',
        { className: styles.component },
        infos.map(function (currentInfo, index) {
          var curClassName = styles.sel_co1;
          switch (index) {
            case 1:
              curClassName = styles.sel_co2 + ' ' + styles.w215;
              break;
            case 2:
              curClassName = styles.sel_co3 + ' ' + styles.w215;
              break;
            case 3:
              curClassName = styles.sel_co4 + ' ' + styles.w215;
              break;
            case 4:
              curClassName = styles.sel_co5 + ' ' + styles.w215;
              break;
            case 5:
              curClassName = styles.sel_co6 + ' ' + styles.w215;
              break;
            default:
              curClassName = styles.sel_co1;
          }
          return _react2.default.createElement(
            _reactRouter.Link,
            { to: '/' + currentInfo.url, key: index,
              className: styles.sel_sl + ' ' + curClassName },
            currentInfo.text
          );
        })
      );
    }
  }]);
  return PersonalCenterTopBar;
}(_react.Component), _class.propTypes = {
  infos: _react.PropTypes.array.isRequired
}, _temp);
exports.default = PersonalCenterTopBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PersonalCenterTopBar/PersonalCenterTopBar.js
 ** module id = 1395
 ** module chunks = 0
 **/